import React from "react";
import { useTranslation } from "react-i18next";
import videoHowItWorks from "../../../assets/videos/page3.mp4";
import "./HowItWorks.css";

const HowItWorks = () => {
  const { t } = useTranslation();
  const steps = t("home.how_it_works.steps", { returnObjects: true });

  return (
    <section className="how-it-works-wrapper">
      <div className="section-divider-top">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 200" preserveAspectRatio="none">
          <path d="M0,0C0,0,203,195.5,452,195.5C701,195.5,839.5,70,1021,70C1236,70,1440,140,1440,140V0Z" fill="#F0EFF7"></path>
        </svg>
      </div>
      <div className="how-it-works-container">
        {/* Left Side: Content */}
        <div className="how-it-works-content">
          <h2 className="how-it-works-title global-title">{t("home.how_it_works.title")}</h2>
          <p className="how-it-works-subtitle global-text">{t("home.how_it_works.subtitle")}</p>

          <div className="how-it-works-label-text global-subtitle">{t("home.how_it_works.how_it_works_label")}</div>

          <div className="steps-list">
            {Array.isArray(steps) && steps.map((step, index) => (
              <div key={index} className="step-item">
                <div className="step-body">
                  <div className="step-header">
                    <div className="step-icon global-diamond-icon"></div>
                    <div className="step-title global-subtitle">{step.title}</div>
                  </div>
                  <div className="home-step-desc global-text">{step.desc}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Right Side: Video */}
        <div className="how-it-works-visual">
          <div className="how-it-works-video-frame">
            <video autoPlay loop muted playsInline className="how-it-works-video">
              <source src={videoHowItWorks} type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
